import React, { useEffect, useState } from "react";
import "./Memories_card.css";
import { memories_baby } from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { memoriesListApi } from "services/memories";
import { dateFormat, dateFormatWithTime } from "utils/dateFormat";

const Memories_card = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [feedingList, setFeedingList] = useState([]);
  const [meta, setMeta] = useState({});
  const [selected, setSelected] = useState({});

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await memoriesListApi({
        childId: _child,
        limit: 5000,
      });
      if (status === 200) {
        setFeedingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="memoeries_parent">
        <div className="memories_wraper">
          {feedingList?.map((item, index) => {
            return (
              <div className="row">
                <div className="col-sm-12 col-md-4 col-lg-4" key={index}>
                  <div className="memories_card_img">
                    <div className="memories_content">
                      <b>{item?.title}</b>
                      <div className="memories_content_date">
                        <span className="timing">
                          {dateFormatWithTime(item?.createdAt)}
                        </span>
                      </div>
                    </div>

                    <div className="memories_img_wraper">
                      {item?.images.map((img, index) => {
                        return <img src={img?.url} key={index} />;
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Memories_card;
